<template>
  <el-upload
    :show-file-list="false"
    :headers="headers"
    :action="baseFileUrl"
    ref="upload"
    v-bind="$attrs"
    v-on="$listeners"
    :on-success="handleSuccess"
    :before-upload="beforeAvatarUpload"
    :on-error="handleError"
    :accept="accept"
  >
    <el-button-group slot="trigger">
      <slot name="trigger">
        <el-button type="primary" size="mini">{{ buttonText }}</el-button>
      </slot>
    </el-button-group>
  </el-upload>
</template>

<script>
import { Loading } from "element-ui";
let loadingInstance = null;
export default {
  name: "Upload",
  data() {
    return {
      // baseFileUrl: process.env.VUE_APP_BASEAPI+url,
      headers: {
        Authorization: `Bearer ${ window.sessionStorage.getItem('token')}`,
      },
      form: {
        name: "",
        url: "",
        size: "",
      },
    };
  },
  props: {
    value: {
      default: "",
    },
    url: {
      default: "/admin/sys-file/upload",
    },
    buttonText: {
      default: "上传",
    },
    accept: {
      default: "",
    },
    size: {
      default: "",
    },
    width: {
      default: "",
    },
    height: {
      default: "",
    },
  },
  computed: {
    baseFileUrl() {
        var baseUrl = window.location.origin+'/api';
        baseUrl = this.url[0] == "/" ? baseUrl : baseUrl + "/";
        return baseUrl +this.url;
    },
  },
  // watch: {
  //   value: {
  //     handler(n, o) {
  //       this.fileUrl = n;
  //     },
  //     immediate: true,
  //     deep: true,
  //   },
  // },
  methods: {
    // 上传校验
    beforeAvatarUpload(file) {
      const _t = this;
      return new Promise(async function (resolve, reject) {
        // loading加载
        loadingInstance = Loading.service({
          text: "文件正在上传中，请等待...",
        });
        // 校验图片大小 1就是1M
        if (_t.size && _t.size < file.size) {
          _t.$message.error(
            "上传图片大小不能超过" + _t.$utils.bytesToSize(_t.size)
          );
          // 上传失败,关闭loading
          loadingInstance.close();
          reject();
          return;
        }
        if (_t.width || _t.height) {
          let f = {};
          f = await _t.getImageSize(file);
          // if (_t.width && _t.width < f.width) {
          //   _t.$message.error("上传图片宽不能超过" + _t.width);
          //   // 上传失败,关闭loading
          //   loadingInstance.close();
          //   reject();
          // }
          // if (_t.height && _t.height < f.height) {
          //   _t.$message.error("上传图片高不能超过" + _t.height);
          //   // 上传失败,关闭loading
          //   loadingInstance.close();
          //   reject();
          // }
          if (
            (_t.height && _t.height != f.height) ||
            (_t.width && _t.width != f.width)
          ) {
            _t.$message.error("上传图片尺寸不符！");
            // 上传失败,关闭loading
            loadingInstance.close();
            reject();
            return;
          }
        }
        _t.$emit("before-upload", e => {
          if (e === false) {
            loadingInstance.close();
            reject();
          }
        });
        resolve();
      });
    },
    // 上传成功
    handleSuccess(response, file, fileList) {
      const res=response.data
      loadingInstance.close();
      if(res){
        const params = {
          ...res,
          name: res.filename,
          size: res.fileSize,
          url: res.fullpath,
          res
        };
        this.$emit("success", params);
        this.$emit("input", params.url);
        // this.fileName = file.name;
      }else{
        this.$message.error(res.msg||res.message||"上传失败");
      }
    },
    // 上传失败
    handleError(err) {
      loadingInstance.close();
      this.$message.error(err.msg||err.message||"上传失败");
    },
    handleIconClick() {
      this.downFile(
        this.fileUrl,
        this.fileUrl.substring(this.fileUrl.lastIndexOf("/") + 1)
      );
    },
    downFile(url, name) {
      const a = document.createElement("a");
      a.download = name || new Date().toLocaleString();
      a.href = url;
      a.target = "_blank";
      document.body.appendChild(a);
      a.click();
      a.remove();
    },
    getImageSize(file) {
      return new Promise(function (resolve, reject) {
        var img = new Image();
        img.onload = function () {
          var width = this.width;
          var height = this.height;
          URL.revokeObjectURL(img.src);
          resolve({ width, height });
        };
        img.onerror = function () {
          reject(new Error("无法加载图片"));
        };
        img.src = URL.createObjectURL(file);
      });
    },
  },
};
</script>

<style lang="less" scoped></style>
